import type { Destination } from '../../types/geo/Destination'

/** Origen de la búsqueda para el texto visible (no sustituye `data-search` / nombre real en datos). */
export type DestinationDisplayMode = 'named' | 'gps_near_me' | 'map_point'

export const DEFAULT_DESTINATION_DISPLAY_MODE: DestinationDisplayMode = 'named'

export function isDestinationDisplayMode(v: unknown): v is DestinationDisplayMode {
  return v === 'named' || v === 'gps_near_me' || v === 'map_point'
}

/** Fila del menú «Ubicación actual» (GPS); no confundir con `element_id === 0`. */
export function isCurrentGpsMenuPick(item: Destination | null | undefined): boolean {
  if (!item) return false
  return item.locationPickKind === 'current_gps'
}
